import {useState} from 'react'
import {PayPeriodData} from '../../../../models/enhancement/pay-period-data'

type ModalMode = 'from' | 'to' | null

interface UsePayPeriodPickerModalProps {
  onFromChange: (payPeriod: PayPeriodData | null) => void
  onToChange: (payPeriod: PayPeriodData | null) => void
  fromPeriod?: PayPeriodData | null
  toPeriod?: PayPeriodData | null
  disabled?: boolean
  isLoading?: boolean
}

export function usePayPeriodPickerModal({
                                          onFromChange,
                                          onToChange,
                                          fromPeriod,
                                          toPeriod,
                                          disabled = false,
                                          isLoading = false
                                        }: UsePayPeriodPickerModalProps) {
  
  const [modalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState<ModalMode>(null)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear())

  const canOpenModal = !disabled && !isLoading
  
  const handleOpenModal = (mode: 'from' | 'to', event: React.MouseEvent<HTMLElement>) => {
    if (canOpenModal) {
      const target = event.currentTarget

      const getYearFromPeriod = (period: PayPeriodData | null | undefined): number | undefined => {
        if (!period?.periodEnd) {
          return undefined
        }
        return new Date(period.periodEnd).getFullYear()
      }

      const yearByMode = {
        from: getYearFromPeriod(fromPeriod),
        to: getYearFromPeriod(toPeriod)
      }

      const initialYear = yearByMode[mode] || new Date().getFullYear()
      
      setSelectedYear(initialYear)
      setModalMode(mode)
      setAnchorEl(target)
      
      setTimeout(() => {
        setModalOpen(true)
      }, 0)
    }
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setModalMode(null)
    setAnchorEl(null)
  }

  const handleSelectPayPeriod = (payPeriod: PayPeriodData) => {
    const handlers = {
      from: onFromChange,
      to: onToChange
    }

    if (modalMode && handlers[modalMode]) {
      handlers[modalMode](payPeriod)
    }
  }

  const handleYearChange = (year: number) => {
    setSelectedYear(year)
  }

  return {
    modalOpen,
    modalMode,
    anchorEl,
    selectedYear,
    canOpenModal,
    handleOpenModal,
    handleCloseModal,
    handleSelectPayPeriod,
    handleYearChange
  }
}